import React from 'react';

class ImageLoader extends React.Component {

    render() {
        let file;

        if (this.props.type === 'image') {
            file = <img src={this.props.src} /* onLoad={this.onload} */ alt={this.props.alt ?? ''} id={this.props.id ?? ''} />
        } else if (this.props.type === 'video') {
            file = <video width="100%" height="100%"
                loop
                autoPlay
                playsInline
                controls={this.props.controls}
                muted={!this.props.muted}
            >
                <source src={this.props.src} type="video/mp4" />
                Your browser does not support the video tag.
            </video>;
        }

        return (
            <>
                {file}
            </>
        );
    }
}

export default ImageLoader;